var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolJsLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58984 27C9.58984 17.0589 17.6487 9 27.5898 9H63.5898C73.531 9 81.5898 17.0589 81.5898 27V63C81.5898 72.9411 73.531 81 63.5898 81H27.5898C17.6487 81 9.58984 72.9411 9.58984 63V27Z",
    fill: "url(#paint0_linear_219_4771)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5898 27H27.5898V63H63.5898V27ZM55.1099 57.1794C53.4413 57.1794 52.4978 56.3091 51.7727 55.1251L49.0235 56.7222C50.0166 58.6845 52.0464 60.1817 55.1881 60.1817C58.4012 60.1817 60.7938 58.5131 60.7938 55.4673C60.7938 52.6422 59.171 51.3857 56.2967 50.1531L55.451 49.7908C53.9996 49.1622 53.371 48.7514 53.371 47.7365C53.371 46.9154 53.999 46.2868 54.9898 46.2868C55.9613 46.2868 56.587 46.6965 57.167 47.7365L59.8013 46.0451C58.687 44.085 57.1407 43.3365 54.9898 43.3365C51.9687 43.3365 50.0356 45.2679 50.0356 47.805C50.0356 50.5593 51.6573 51.8622 54.0984 52.9022L54.9442 53.2651C56.487 53.94 57.407 54.3508 57.407 55.5108C57.407 56.4788 56.5116 57.1794 55.1099 57.1794ZM41.9995 57.1583C40.8373 57.1583 40.3538 56.3612 39.8224 55.4183L37.0687 57.0854C37.8664 58.7737 39.435 60.1754 42.1436 60.1754C45.1413 60.1754 47.195 58.5811 47.195 55.0782V43.5297H43.8121V55.0326C43.8121 56.7234 43.111 57.1583 41.9995 57.1583Z",
    fill: "url(#paint1_linear_219_4771)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4771",
    x: 0.589844,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_219_4771"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4771",
    x1: 45.5898,
    y1: 9,
    x2: 45.5898,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4771",
    x1: 45.5898,
    y1: 27,
    x2: 45.5898,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolJsLong);
export default __webpack_public_path__ + "static/media/symbol-js-long.81358ec60c8367644a454dd93fd510fb.svg";
export { ForwardRef as ReactComponent };